/* eslint-disable no-unused-vars */

/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_MASSUPLOAD_URL, COMMON_HEADER_CONFIG} from "../config";
import {MASSUPLOAD_TYPE} from "../constants";

class MassuploadService {
  getAccessToken = () => localStorage.getItem("accessToken");

  update = (data) =>
    new Promise((resolve, reject) => {
      const type = data.get("type");
      const url = `${API_MASSUPLOAD_URL}/mass-upload/update-item`;

      if (url !== "") {
        const config = {
          method: "POST",
          url,
          headers: {
            ...COMMON_HEADER_CONFIG,
            Authorization: `Bearer ${this.getAccessToken()}`
          },
          data
        };

        axios(config)
          .then((response) => {
            if (response.data && response.data.code === "success") {
              resolve(response.data.data);
            } else {
              resolve(response.data.data);
            }
          })
          .catch((error) => {
            if (error.response.status === 503) {
              resolve(error);
            }
            reject(error);
          });
      }
    });

  upload = (data) =>
    new Promise((resolve, reject) => {
      const type = data.get("type");
      let url = "";
      if (type === MASSUPLOAD_TYPE.PRICING) {
        url = `${API_MASSUPLOAD_URL}/mass-upload/import-sku-pricing`;
      } else if (type === MASSUPLOAD_TYPE.PRODUCT) {
        url = `${API_MASSUPLOAD_URL}/mass-upload/import-items`;
      } else if (type === MASSUPLOAD_TYPE.STOCK) {
        url = `${API_MASSUPLOAD_URL}/mass-upload/import-stock`;
      } else if (type === MASSUPLOAD_TYPE.CODE) {
        url = `${API_MASSUPLOAD_URL}/mass-upload/import-code`;
      } else if (type === MASSUPLOAD_TYPE.MULTI_BARCODE) {
        url = `${API_MASSUPLOAD_URL}/mass-upload/import-multi-barcode`;
      }
      if (url !== "") {
        const config = {
          method: "POST",
          url,
          headers: {
            ...COMMON_HEADER_CONFIG,
            Authorization: `Bearer ${this.getAccessToken()}`
          },
          data
        };

        axios(config)
          .then((response) => {
            if (response.data && response.data.code === "success") {
              resolve(response.data.data);
            } else {
              resolve(response.data.data);
            }
          })
          .catch((error) => {
            if (error.response.status === 503) {
              resolve(error);
            }
            reject(error);
          });
      }
    });

  getMassUploadHistory = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_MASSUPLOAD_URL}/history?`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 100,
          page: 1,
          ...data,
          sort: "created_at DESC"
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const massuploadService = new MassuploadService();

export default massuploadService;
